/**
 * Created by shem.mahluf on 06/09/2016.
 */
import initialState from '../store/initialstate';
import C from '../constants/app';

export default (state = initialState().app, action = null) => {
    let newObj = {};
    switch (action.type) {
        case C.GET_SSP_PERMISSIONS_LIST:
            Object.assign(newObj, action.payload);
            newObj.isFetched = true;
            return state.set(C.SSP_PERMISSIONS_LIST, newObj);
        case C.GET_THEME:
            return state.set(C.THEME, action.payload);
        case C.SET_IS_FETCHING:{
            let counter =  state.get(C.FETCHING_COUNTER) + (action.payload ? 1 : -1);
            return state.set(C.FETCHING_COUNTER, Math.max(counter,0)).set(C.IS_FETCHING, counter > 0);
        }
        case C.CLOSE_CHARGER:
            return state.set(C.FETCHING_COUNTER, 0).set(C.IS_FETCHING,false);
        case C.GET_SSP_PREFERENCES:
            return state.set(C.SSP_PREFERENCES, action.payload);
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./reducers/app.js